'use strict';

angular.module('app.information.terms', [])
    .config([
        '$stateProvider',
        'PRODUCT',
        function ($stateProvider, product) {
            return $stateProvider.state('app.information.terms', {
                url: '/information/terms?:section',
                templateUrl: 'assets/templates/' + product.Code + '/information/termsView.html',
                controller: [
                    '$scope', '$location', '$stateParams', '$anchorScroll', '$transitions',
                    function ($scope, $location, $stateParams, $anchorScroll, $transitions) {
                        $anchorScroll($stateParams.section);
                        $transitions.onSuccess({}, () => {
                          if ($stateParams.section) {
                            $anchorScroll($stateParams.section);
                          }
                        });
                    }
                ],
                title: 'Terms of Service'
            });
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/information/terms/terms.js